var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    _setup.Button,
    {
      staticClass: "btn-sm p-0 px-1",
      attrs: { disabled: !_setup.hasEditAccess },
      nativeOn: {
        click: function ($event) {
          return _setup.gotToThemesEditor.apply(null, arguments)
        },
      },
    },
    [
      _vm._v("\n    " + _vm._s(_setup.contentTypeTitle)),
      _setup.contentTypeLabel
        ? _c("span", [_vm._v(" - " + _vm._s(_setup.contentTypeLabel))])
        : _vm._e(),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }